import type { Organization } from '#dn-types/org.ts';
import type { Actor } from '#dn-types/user.ts';
import { get } from './fetch.ts';

// GET /v2/whoami
export type WhoAmIResult = Actor & {
  organization: Organization;
};

export async function whoami(init?: RequestInit) {
  return get<WhoAmIResult>('/v2/whoami', init).then((res) => res.data);
}
